import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSafe = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.818 2.688H7.183A4.183 4.183 0 0 0 3 6.87v7.435a4.18 4.18 0 0 0 4.183 4.181h9.634A4.18 4.18 0 0 0 21 14.304V6.87a4.18 4.18 0 0 0-4.182-4.182"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.368 20.818h-2.262M7.897 20.818H5.634M14.412 7.367v1.074M14.412 12.734v1.075M11.62 8.98l.926.536M16.276 11.663l.927.537M11.62 12.2l.926-.537M16.276 9.516l.927-.537M15.93 9.066a2.148 2.148 0 1 1-3.038 3.038 2.148 2.148 0 0 1 3.038-3.038M8.3 7.375h-.39a1.11 1.11 0 0 0-1.11 1.11v4.204c0 .612.497 1.11 1.11 1.11h.39"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSafe);
export default ForwardRef;
